import { Box } from '@mui/material'
import AlertMessage from 'Components/AlertMessage'
import { DocumentAccordion } from 'Components/DocumentList/DocumentAccordion'
import { type documentTypeModel } from '.'
import { type income } from 'core/types'

interface DocumentListProps {
  documentTypes: documentTypeModel[]
  incomeRecords: income[] | null
  editable: boolean
  showDisclaimer: boolean
  canVerify: boolean
  onDelete: (id: number, documentTypeID: number, index: number, verified: boolean) => Promise<boolean>
  onVerify: (documentTypeID: number, index: number, verified: boolean) => Promise<boolean>
  onUpload: (documentTypeID: number, file: File, year: number | null) => Promise<boolean>
  onDownload?: (id: number) => Promise<boolean>
}

export function DocumentListEdit (props: DocumentListProps): JSX.Element {
  const documentList = props.documentTypes

  return <Box width={'100%'} marginTop={ '10px' }>
    {props.showDisclaimer && documentList.length > 0 && (
      <AlertMessage type={'warning'} message={'Please help keep personal information safe and secure by redacting SSNs and other identifying information'} dismissible={true} />
    )}

    {documentList.map((d, i, v) => {
      const handleDelete = async (id: number, index: number, verified: boolean): Promise<void> => {
        await props.onDelete(id, d.documentTypeID, index, verified)
      }

      const handleVerifiedChanged = async (index: number, verified: boolean): Promise<void> => {
        await props.onVerify(d.documentTypeID, index, verified)
      }

      const handleFileUploaded = async (file: File, year: number | null): Promise<void> => {
        await props.onUpload(d.documentTypeID, file, year)
      }

      return <Box sx={{ marginBottom: '20px', marginTop: '20px' }} key={i}>
        <DocumentAccordion
          documentType={d}
          editable={props.editable}
          canVerify={props.canVerify}
          onDelete={async (id, index, verified) => { await handleDelete(id, index, verified) }}
          onVerifiedChanged={handleVerifiedChanged}
          uploadDocument={handleFileUploaded}
          downloadDocument={props.onDownload}
          incomeRecords={(d.incomeRelated ? props.incomeRecords : null)}
        />
      </Box>
    })}
    {documentList.length === 0 && <AlertMessage type={'error'} message={'No document types are configured for this ISD'} dismissible={false} />}
  </Box>
}
